import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Image } from '../../../../common/image'
import { Notification } from '../../../../common/notification'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatText } from '../../../../helpers/value'
import { LinkComponent } from '../../../common/html/LinkComponent'
import { TitleComponent } from '../../../common/html/TitleComponent'
import image from '../../../common/images/DefaultImage.png'
import { getDataNewsAndEvent } from '../store/slice'
import classes from './newsAndEvents.module.scss'

const HEIGHT_IMG = 48
const WIDTH_IMG = 120

export const NewsAndEvents = () => {
  const data = useSelector(getDataNewsAndEvent)
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className="flexColumn h100">
      <TitleComponent
        title="dashboard.featured.newsAndEvent"
        className="py1"
        style={{ paddingTop: 20, paddingBottom: 8 }}
      />
      <div className="flex1 h100">
        {!data.length ? (
          <Notification />
        ) : (
          <ScrollComponent>
            {data.map((item, index) => (
              <ItemNewsEvent item={item} key={index} locale={locale} />
            ))}
          </ScrollComponent>
        )}
      </div>
    </div>
  )
}

export const ItemNewsEvent = ({ item, locale }) => {
  return (
    <LinkComponent href={item?.sourceUrl}>
      <div className={classes.itemNewsEvent}>
        <Image
          src={item?.imageUrl ? item?.imageUrl : image}
          alt={item?.title}
          style={{ width: WIDTH_IMG, height: HEIGHT_IMG, objectFit: 'cover' }}
        />
        <div className="flex1">
          <Element className={classes.title} style={{ lineHeight: '16px' }}>
            <TextEllipsisStaticLine
              lineClamp={2}
              text={formatText(item?.title)}
              isI18n={false}
            />
          </Element>
          <Element
            elementName="p"
            className={classes.date}
            style={{ fontSize: 10, color: '#9C9C9C' }}
          >
            {formatDateTime(item?.publicDate, FORMAT.DATE, locale)}
          </Element>
        </div>
      </div>
    </LinkComponent>
  )
}
